/*
 * - Definitions for Aquatic Resources queries
 */
import AquaticResourceService from './service';
import {
  GetAquaticResourceResponse,
  GetAquaticResourcesQueryParams,
  GetAquaticResourceUsaceDistrictValidationResponse,
  GetAquaticResourceWaterNamesResponse,
  GetValidateAquaticResourcesQueryParams,
  GetValidationAquaticResourcesResponse,
  GetAquaticResourceGeometryBoundaryValidationResponse,
  GetAquaticResourceGeometriesResponse,
} from './types';

export const AQUATIC_RESOURCES_QUERY_KEYS = {
  ADD_AQUATIC_RESOURCES: 'ADD_AQUATIC_RESOURCES',
  DELETE_AQUATIC_RESOURCES: 'DELETE_AQUATIC_RESOURCES',
  DELETE_ALL_AQUATIC_RESOURCES: 'DELETE_ALL_AQUATIC_RESOURCES',
  GET_AQUATIC_RESOURCES_GEOMETRIES: 'GET_AQUATIC_RESOURCES_GEOMETRIES',
  GET_AQUATIC_RESOURCES_VALIDATIONS: 'GET_AQUATIC_RESOURCES_VALIDATIONS',
  GET_AQUATIC_RESOURCES_USACE_DISTRICT_VALIDATION: 'GET_AQUATIC_RESOURCES_USACE_DISTRICT_VALIDATION',
  GET_AQUATIC_RESOURCES: 'GET_AQUATIC_RESOURCES',
  GET_AQUATIC_RESOURCES_WATERNAMES: 'GET_AQUATIC_RESOURCES_WATERNAMES',
  UPDATE_AQUATIC_RESOURCES: 'UPDATE_AQUATIC_RESOURCES',
};

export class AquaticResourcesQueries {
  public static readonly getAquaticResources = async (
    params: GetAquaticResourcesQueryParams
  ): Promise<GetAquaticResourceResponse> => {
    const data: GetAquaticResourceResponse = await AquaticResourceService.getAquaticResources(params);

    return data;
  };
  public static readonly getAquaticResourceGeometries = async (): Promise<GetAquaticResourceGeometriesResponse> => {
    const data: GetAquaticResourceGeometriesResponse = await AquaticResourceService.getAquaticResourceGeometries();

    return data;
  };
  public static readonly getAquaticResourcesWaterNames = async (): Promise<GetAquaticResourceWaterNamesResponse> => {
    const data: GetAquaticResourceWaterNamesResponse = await AquaticResourceService.getAquaticResourcesWaterNames();

    return data;
  };
  public static readonly validateAquaticResources = (
    params: GetValidateAquaticResourcesQueryParams
  ): Promise<GetValidationAquaticResourcesResponse> => AquaticResourceService.validateAquaticResources(params);
  public static readonly validateAquaticResourceUsaceDistrict =
    (): Promise<GetAquaticResourceUsaceDistrictValidationResponse> =>
      AquaticResourceService.validateAquaticResourceUsaceDistrict();
  public static readonly validateAquaticResourceGeometryBoundary =
    (): Promise<GetAquaticResourceGeometryBoundaryValidationResponse> =>
      AquaticResourceService.validateAquaticResourceGeometryBoundary();
}
